// externals
import { Redirect } from 'react-router';
import { StyleSheetManager as ScStyleSheetManager, ThemeProvider } from 'styled-components';

// libraries
import type { Dealer } from '@makemydeal/dr-shared-types';
import type { FeatureTogglesAndUrlOnly } from '@makemydeal/dr-shared-store';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { OPEN_DEAL_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import { Header } from '@makemydeal/dr-activities-open-deal';

// config
import { openDealConfiguration } from '../activities/open-deal-dashboard';

// components
import { BodyContainer } from './BodyContainer';

// style
import './routing.css';
import { openDealAllRoutes } from '../activities/open-deal-dashboard/config';

export type RoutesProps = {
    toggles: FeatureTogglesAndUrlOnly;
    dealer: Partial<Dealer>;
};

const StyleSheetManager = ScStyleSheetManager as any;

export const Routes: React.FC<RoutesProps> = () => {
    const theme = useInterstateTheme();

    const getLandingPage = () => {
        return openDealAllRoutes.DASHBOARD;
    };

    return (
        <ThemeProvider theme={theme}>
            <StyleSheetManager disableCSSOMInjection>
                <>
                    <Header appPrefix={OPEN_DEAL_APP_PREFIX} />

                    <Redirect to={getLandingPage()} />
                    <BodyContainer>
                        <openDealConfiguration.routingComponent />
                    </BodyContainer>
                </>
            </StyleSheetManager>
        </ThemeProvider>
    );
};
